import { render, staticRenderFns } from "./DashboardNew.vue?vue&type=template&id=112477bc&scoped=true"
import script from "./DashboardNew.vue?vue&type=script&lang=js"
export * from "./DashboardNew.vue?vue&type=script&lang=js"
import style0 from "./DashboardNew.vue?vue&type=style&index=0&id=112477bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112477bc",
  null
  
)

export default component.exports